import dlv from 'dlv';
import * as React from 'react';
import AppConfig from '../AppConfig';
import Seo from '../Seo';
import { makeImageLink } from '../utils/image';
export const EntitySeo = ({ entity, pathname, }) => {
    const title = dlv(entity, 'seo.title') || entity.title;
    const description = dlv(entity, 'seo.description') || entity.description;
    const keywords = dlv(entity, 'seo.keywords') || [];
    const meta = dlv(entity, 'seo.meta') || [];
    return (React.createElement(AppConfig, null, ({ imageHost }) => {
        const image = entity.image && makeImageLink({ image: entity.image, host: imageHost });
        return (React.createElement(Seo, { pathname: pathname, title: title, description: description, keywords: keywords, image: image, meta: meta }));
    }));
};
export default EntitySeo;
//# sourceMappingURL=index.js.map